/**
 * 类中采用发布订阅的方式来获取地图的状态，通过 on 方法可获取不同的时间点发生的事件
 */

/* eslint-disable */
import scriptjs from 'scriptjs';

class Map {
    constructor(options) {
        // 实例数据
        this.mapInstance = {};
        this.dep = [];
        this.plugins = {};
        this.extraTools = {};
        this.controlPlugins = ['AMap.Scale', 'AMap.ToolBar', 'AMap.OverView', 'AMap.ControlBar', 'AMap.MapType'];
        // 内置配置
        const baseUrl = 'https://webapi.amap.com/maps';
        const defaultTools = [
            'AMap.ToolBar',
            'AMap.PolyEditor',
            'AMap.Geocoder',
            'AMap.Autocomplete',
            'AMap.PlaceSearch',
            'AMap.MouseTool',
            'AMap.Geolocation'
        ];
        const defaultInitData = {
            zoom: 12,
            resizeEnable: true
        };
        // 地图基础配置
        const key = options.key || 'bae83b6a8cb83d5997aac379bee251f5';
        const version = options.version || '1.4.15';
        const requestUrl = baseUrl + '?v=' + version + '&key=' + key + '&plugin=' + defaultTools.join(',');
        const initData = options.initData ? options.initData : {};
        // 相关初始化配置
        options.initData = {
            ...defaultInitData,
            ...initData
        };
        scriptjs(requestUrl, () => {
            console.log('地图初始化完成...');
            console.log('开始初始化插件...');
            this.emit('initComplete');
            setTimeout(() => {
                this.init(options);
            }, 1000);
        });
    }

    // 实例化地图
    init(options) {
        this.mapInstance = new AMap.Map(options.id || 'container', options.initData);
        this.mapInstance.on('complete', () => {
            console.log('地图绘制完成...');
            console.log('开始初始化插件...');
            const pluginArray = [{
                    name: 'ToolBar',
                    isNeedInstance: false
                },
                {
                    name: 'PolyEditor',
                    isNeedInstance: true
                },
                {
                    name: 'Geocoder',
                    isNeedInstance: false
                },
                {
                    name: 'Autocomplete',
                    isNeedInstance: false
                },
                // {
                //     name: 'MouseTool',
                //     isNeedInstance: true
                // },
                {
                    name: 'Geolocation',
                    isNeedInstance: false
                }
            ];
            this.loadingDefaultPlugins(pluginArray);
        });
    }

    // 初始化插件
    loadingDefaultPlugins(pluginArray) {
        pluginArray.forEach((pluginItem) => {
            // debugger
            let name = pluginItem.name;
            if (pluginItem.isNeedInstance === true) {
                this.plugins[name] = new AMap[name](this.mapInstance);
            } else {
                this.plugins[name] = new AMap[name]();
            }
        });
        console.log('插件实例化完成...');
        this.emit('complete');
    }

    // 使用插件或者服务
    usePlugins(name, plugin, type) {
        // 控件类
        if (this.controlPlugins.indexOf(name) > -1 || type === 'control') {
            this.mapInstance.addControl(plugin);
        }
        // 服务类
        else if (type === 'service') {
            this.mapInstance.plugin(plugin);
        }
    }

    // 创建坐标系
    createPixel(offsetX = 0, offsetY = 0) {
        return new AMap.Pixel(offsetX, offsetY);
    }

    // 创建定位信息
    createLnglat(lng, lat) {
        return new AMap.LngLat(lng, lat);
    }

    // 创建尺寸信息
    createSize(width, height) {
        return new AMap.Size(width, height);
    }

    // 创建 Icon
    createIcon(img, width, height, offsetX = 0, offsetY = 0) {
        const icon = new AMap.Icon({
            size: new AMap.Size(width, height),
            image: img,
            imageOffset: new AMap.Pixel(offsetX, offsetY),
            imageSize: new AMap.Size(width, height)
        });
        return icon;
    }

    // 创建 Marker（附带 icon）
    createMarker(iconObject, lng, lat, extData = {}, offsetX = 0, offsetY = 0, title = '') {
        const marker = new AMap.Marker({
            position: new AMap.LngLat(lng, lat),
            offset: new AMap.Pixel(offsetX, offsetY),
            icon: iconObject, // 添加 Icon 实例
            title: title,
            extData: extData
        });
        return marker;
    }

    // 创建简单的 Marker
    createSimpleMarker(lng, lat, image, offsetX = 0, offsetY = 0, title = '') {
        const simpleMarker = new AMap.Marker({
            position: new AMap.LngLat(lng, lat),
            offset: new AMap.Pixel(offsetX, offsetY),
            icon: image,
            title: title
        });
        return simpleMarker;
    }

    // 创建 label
    setLabel(marker, direction = '', content = '', offsetX, offsetY) {
        if (offsetX === undefined || offsetY === undefined) {
            marker.setLabel({
                direction: direction,
                content: content
            });
        } else {
            marker.setLabel({
                direction: direction,
                content: content,
                offset: new AMap.Pixel(offsetX, offsetY)
            });
        }
    }

    // 设置 label 的标题
    setTitle(marker, title) {
        marker.setTitle(title);
    }

    // 创建信息窗
    createInfoWindow(options) {
        this.extraTools.infoWindow = new AMap.InfoWindow(options);
        return this.extraTools.infoWindow;
    }

    // 获取实例化的信息窗
    getInfoWindow() {
        if (this.extraTools.infoWindow) {
            return this.extraTools.infoWindow;
        } else {
            this.createInfoWindow();
        }
    }

    // 设置 Maker 的 ICON
    updateMakerIcon(marker, icon, width = 24, height = 30) {
        let IconObj = this.createIcon(icon, width, height);
        marker.setIcon(IconObj);
    }

    // 更新 infowindow 内容
    updateInfoWindow(content) {
        this.extraTools.infoWindow.setContent(content);
    }

    // 打开 infowindow
    openInfoWindow(lnglat) {
        this.extraTools.infoWindow.open(this.mapInstance, lnglat);
    }

    // 关闭 infoWindow
    closeInfoWindow() {
        this.extraTools.infoWindow.close();
    }

    // 移除覆盖物
    removeMarker(markerList) {
        this.mapInstance.remove(markerList);
    }

    // 添加覆盖物
    addMarker(markerList) {
        this.mapInstance.add(markerList);
    }

    // 设置中心点
    setCenter(lng, lat) {
        let lnglat = this.createLnglat(lng, lat);
        this.mapInstance.setCenter(lnglat);
    }

    // 设置层级和中心点
    setZoomAndCenter(zoomLevel, lng, lat) {
        this.mapInstance.setZoomAndCenter(zoomLevel, [lng, lat]);
    }

    // 适应所有的覆盖物
    setFitView(markerList) {
        if (markerList && markerList.length !== 0) {
            this.mapInstance.setFitView(markerList);
        } else {
            this.mapInstance.setFitView();
        }
    }

    // 正向编码（地理位置转换为经纬度）
    toLocation(address) {
        return new Promise((resolve, reject) => {
            this.plugins.Geocoder.getLocation(address, function (status, result) {
                if (status === 'complete' && result.info === 'OK') {
                    if (result.geocodes.length === 0) {
                        reject(new Error('没有找到匹配的数据'));
                    } else {
                        resolve(result);
                    }
                } else {
                    reject(new Error('没有找到匹配的数据'));
                }
            });
        });
    }

    // 逆向编码（经纬度转换为地理位置）
    toAddress(lnglat) {
        return new Promise((resolve, reject) => {
            this.plugins.Geocoder.getAddress(lnglat, function (status, result) {
                if (status === 'complete' && result.regeocode) {
                    resolve(result.regeocode.formattedAddress);
                } else {
                    reject(new Error('address has not found...'));
                }
            });
        });
    }

    // 模糊搜索
    search(address) {

        return new Promise((resolve, reject) => {
            this.plugins.Autocomplete.search(address, function (status, result) {
                if (result.tips) {
                    resolve(result.tips);
                } else {
                    reject(new Error('没有找到匹配的数据'));
                }
            });
        });
    }

    // 移除监听事件
    off(eventName, fn) {
        this.mapInstance.off(eventName, fn);
    }

    // 添加监听事件
    add(eventName, fn) {
        this.mapInstance.on(eventName, fn);
    }

    // 事件发布
    pub(name) {
        this.dep.forEach((event) => {
            if (event.name === name) {
                event.fn.apply();
            }
        });
    }

    // 事件触发
    emit(name) {
        this.pub(name);
    }

    // 事件接收
    on(name, fn) {
        this.dep.push({
            name,
            fn
        });
    }

    // 安装插件方法,用于额外实例化插件
    install(pluginName, fn) {
        AMap.plugin('AMap' + pluginName, function () {
            fn.apply(fn);
        });
    }

    // 返回地图实例
    getInstance() {
        return this.mapInstance;
    }

    // 返回高德地图实例
    getMapInstance() {
        return AMap;
    }
}

export default Map;
